import { environment } from "./../environments/environment";
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class InstitutionService {
    constructor(http) {
        this.http = http;
    }
    getStats(institutionName, per_page = 10, page = 1, advisorId = null) {
        return this.http.get(`${environment.base_url}/institutions/${institutionName}/get_stats?page=${page}&per_page=${per_page}${advisorId ? "&advisor_id=" + advisorId : ""}`);
    }
    paginateInstitutionResearcher(institutionName, per_page = 20, page = 1, term = "", month = new Date().getMonth() + 1, year = new Date().getFullYear(), prod_or_register) {
        return this.http.get(`${environment.base_url}/institutions/${institutionName}/get_researchers?per_page=${per_page}&page=${page}&term=${term}&year=${year.toString()}&month=${month}&prod_or_register=${prod_or_register}`);
    }
    paginateInstitutionStudents(institutionName, per_page = 20, page = 1, term = "") {
        return this.http.get(`${environment.base_url}/institutions/${institutionName}/get_students?per_page=${per_page}&page=${page}&term=${term}`);
    }
    paginateInstitutionTeachers(institutionName, per_page = 20, page = 1, term = "") {
        return this.http.get(`${environment.base_url}/institutions/${institutionName}/get_teachers?per_page=${per_page}&page=${page}&term=${term}`);
    }
    countResearchers(institutionName) {
        return this.http.get(`${environment.base_url}/institutions/${institutionName}/count_researchers`);
    }
    countTeachers(institutionName) {
        return this.http.get(`${environment.base_url}/institutions/${institutionName}/count_teachers`);
    }
    countStudents(institutionName) {
        return this.http.get(`${environment.base_url}/institutions/${institutionName}/count_students`);
    }
    savePrice(partnership, institutionId) {
        return this.http.post(`${environment.base_url}/institutions/save_price`, {
            partnership,
            institution_id: institutionId,
        });
    }
    get(institutionId) {
        return this.http.get(`${environment.base_url}/institutions/${institutionId}`);
    }
    getInstitutionByName(institutionName) {
        return this.http.get(`${environment.base_url}/institutions/${institutionName}`);
    }
    getInstitutions() {
        return this.http.get(`${environment.base_url}/institutions/get_institutions`);
    }
    getOrientations(institutionName, startDate, endDate) {
        return this.http.get(`${environment.base_url}/institutions/${institutionName}/get_orientations?start_date=${startDate}&end_date=${endDate}`);
    }
    getOrientationsByUser(advisorId, studentId, startDate, endDate) {
        return this.http.get(`${environment.base_url}/institutions/${advisorId}/${studentId}/get_orientations?start_date=${startDate}&end_date=${endDate}`);
    }
    getOrientationsByProject(projectId, startDate, endDate) {
        return this.http.get(`${environment.base_url}/institutions/${projectId}/get_orientations_by_project`);
    }
    bindUsers(bind, users, institution = "") {
        return this.http.put(`${environment.base_url}/institutions/bind_users`, { bind, users, institution });
    }
    saveOrientation(description, studentId, projectId, startedAt, endedAt) {
        return this.http.post(`${environment.base_url}/institutions/save_orientation`, {
            stage_description: description,
            student_id: studentId,
            project_id: projectId,
            started_at: startedAt,
            ended_at: endedAt,
        });
    }
    setOrientationDescription(orientationId, description) {
        return this.http.put(`${environment.base_url}/institutions/set_orientation_description`, { orientation_id: orientationId, orientation_description: description });
    }
    paginateOrientations(advisorId, studentId, page = 1) {
        return this.http.get(`${environment.base_url}/institutions/${advisorId}/${studentId}/get_paginate_orientations?page=${page}`);
    }
    paginateOrientationsByProject(projectId, page = 1) {
        return this.http.get(`${environment.base_url}/institutions/${projectId}/get_paginate_orientations_by_project?page=${page}`);
    }
    updateOrientation(orientationId, stageDescription, startedAt, endedAt) {
        return this.http.put(`${environment.base_url}/institutions/update_orientation`, {
            orientation_id: orientationId,
            stage_description: stageDescription,
            started_at: startedAt,
            ended_at: endedAt,
        });
    }
    getProjectAuthorId(projectId) {
        return this.http.get(`${environment.base_url}/institutions/${projectId}/get_project_author_id`);
    }
    getProjectAdvisorId(projectId) {
        return this.http.get(`${environment.base_url}/institutions/${projectId}/get_project_advisor_id`);
    }
    save(form) {
        if (form.id) {
            return this.update(form);
        }
        return this.create(form);
    }
    create(form) {
        return this.http.post(`${environment.base_url}/institutions`, form);
    }
    update(form) {
        return this.http.put(`${environment.base_url}/institutions/${form.id}`, form);
    }
}
InstitutionService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function InstitutionService_Factory() { return new InstitutionService(i0.ɵɵinject(i1.HttpClient)); }, token: InstitutionService, providedIn: "root" });
